<template>
  <v-toolbar
    id="core-toolbar"
    :class="{ 'group-toolbar': !!group }"
    style="background: #fff;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="primary--text font-weight-light"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          aria-label="Open navigation"
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>

        Welcome, <span style="font-weight: bold">{{ company }}</span>

      </v-toolbar-title>
    </div>
    <img
      v-if="group && group.code === 'sgws-az'"
      :src="require('@/assets/sgws-logo.svg')"
      class="group-logo"
      alt="Southern Glazer’s Wine &amp; Spirits">
    <div
      v-if="company_logo"
      class="toolbar-items"
      style="height:64px;width:150px">
      <v-img
        :src="company_logo"
        contain
        style="height:60px;" />
    </div>
    <v-spacer />
    <v-toolbar-items>
      <v-flex
        align-center
        layout
        py-2
      >
        <router-link
          v-ripple
          :to="homePath"
          class="toolbar-items analytics-link"
          aria-label="Analytics"
          @click.native="group && $emit('navigate', 0)"
        >
          <v-icon color="primary">mdi-finance</v-icon>
        </router-link>

        <v-btn
          v-if="!group"
          flat
          color="primary"
          title="Sign out"
          aria-label="Sign Out"
          @click="logout">
          <v-icon left>mdi-logout</v-icon>
          <span class="signout-label">Sign Out</span>
        </v-btn>

      </v-flex>

    </v-toolbar-items>
  </v-toolbar>
</template>

<script>

import {
  mapMutations
} from 'vuex'
import { TokenService } from '../../services/storage.service'

export default {
  props: {
    group: { type: Object, default: null },
    homePath: { type: String, default: '/analytics' }
  },
  data: () => ({
    notifications: [],
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  computed: {
    company () {
      return this.group ? this.group.name : this.$store.state.company_name
    },
    company_logo () {
      return this.group ? false : this.$store.state.company_logo || false
    }
  },

  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },

  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
    if (!this.group) this.$store.dispatch('get_company')
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    logout () {
      if (this.group) {
        this.$emit('logout')
        return
      }
      TokenService.clearLogin()
      TokenService.clearOneTimeSetup()
      this.$store.commit('setUserProfile', null)
      this.$router.replace('/login')
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    }
  }
}
</script>

<style>
  .group-logo {
    width: 54px;
    height: 54px;
    object-fit: contain;
    flex-shrink: 0;
    margin-left: 24px;
  }

  #core-toolbar a {
    text-decoration: none;
  }

  #core-toolbar .v-toolbar__content .v-toolbar__items .toolbar-items {
    height: 64px;
  }

  @media (max-width: 600px) {
    .group-logo {
      width: 40px;
      height: 40px;
      margin-left: 12px;
    }

    #core-toolbar.group-toolbar .analytics-link,
    #core-toolbar.group-toolbar .signout-label {
      display: none;
    }

    #core-toolbar.group-toolbar .v-toolbar-title {
      min-width: 0;
    }

    #core-toolbar.group-toolbar .v-toolbar__title {
      font-size: 16px;
    }

    #core-toolbar.group-toolbar .v-btn[title="Sign out"] {
      min-width: 40px;
      margin: 0;
    }

    #core-toolbar.group-toolbar .v-btn[title="Sign out"] .v-icon {
      margin: 0;
    }
  }
</style>
